/**
 * 设备判断 & "仅移动端访问"限制
 * 限制开关配置在 vue.config.js -> mobileOnly
 */

/**
 * 是否开启"仅移动端访问"限制
 * true  : 非移动端访问会被拦截到 messagePage（请在移动端打开链接）
 * false : 不做限制，PC 也可正常访问，方便本地调试
 */
export function isMobileOnlyEnabled() {
  const value = process.env.VUE_APP_MOBILE_ONLY;
  if (value === undefined || value === null || value === "") {
    return true; // 未注入时默认开启限制
  }
  return String(value).toLowerCase() !== "false";
}

/**
 * 判断当前设备是否为移动端（手机 / 平板）
 */
export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isMobileUa = /mobile|android|iphone|ipod|ipad|windows phone|blackberry|bb\d+|opera mini|webos/i.test(
    ua
  );
  if (isMobileUa) return true;
  // iPadOS 13+ 的 UA 与 PC 一致（Macintosh），通过多点触控区分
  const isMac = /macintosh/i.test(ua);
  const maxTouchPoints =
    typeof navigator.maxTouchPoints === "number" ? navigator.maxTouchPoints : 0;
  return isMac && maxTouchPoints > 1;
}
